import { proxyCustomElement, HTMLElement, h, Host } from '@stencil/core/internal/client';

const mapyIconCss = ":host{display:inline-block}:host(:not([size])),:host([size=\"24\"]){width:24px;height:24px}:host([size=\"8\"]){width:8px;height:8px}:host([size=\"16\"]){width:16px;height:16px}:host([size=\"32\"]){width:32px;height:32px}:host svg{display:block;width:100%;height:100%;fill:currentColor}";
const MapyIconStyle0 = mapyIconCss;

const MapyIcon = /*@__PURE__*/ proxyCustomElement(class MapyIcon extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.d = '';
        this.size = 24;
    }
    render() {
        return (h(Host, null, h("svg", { x: "0px", y: "0px", viewBox: `0 0 ${this.size} ${this.size}`, focusable: "false" }, h("path", { "fill-rule": "evenodd", d: `${this.d}` }))));
    }
    static get style() { return MapyIconStyle0; }
}, [1, "mapy-icon", {
        "d": [513],
        "size": [514]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["mapy-icon"];
    components.forEach(tagName => { switch (tagName) {
        case "mapy-icon":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, MapyIcon);
            }
            break;
    } });
}
defineCustomElement();

export { MapyIcon as M, defineCustomElement as d };

//# sourceMappingURL=mapy-icon2.js.map